import React from 'react'
import { Avatar, Box, Chip, IconButton, Menu, MenuItem, Typography } from '@mui/material'
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import MenuRoundedIcon from '@mui/icons-material/MenuRounded'
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded'
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded'
import { getUsuarioFromSession } from '../../utils/permisos'

export const Topbar = ({
  onMenuClick,
  sidebarCollapsed,
  sidebarOpen,
  mobile,
  onLogout,
  session,
  sessionStatus,
  usingFallback,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const usuario = getUsuarioFromSession(session)
  const nombreUsuario = usuario?.displayName || usuario?.username || 'Usuario'
  const inicial = nombreUsuario.trim()[0]?.toUpperCase() || 'U'

  const menuTitle = mobile
    ? (sidebarOpen ? 'Cerrar menu' : 'Abrir menu')
    : (sidebarCollapsed ? 'Mostrar menu lateral' : 'Ocultar menu lateral')

  const handleLogout = () => {
    setAnchorEl(null)
    onLogout?.()
  }

  return (
    <Box component="header" className="suite-topbar">
      <Box className="suite-topbar-left">
        <Box className="suite-topbar-navigation">
          <IconButton onClick={onMenuClick} className="suite-icon-button" title={menuTitle} aria-label={menuTitle} aria-expanded={mobile ? Boolean(sidebarOpen) : !sidebarCollapsed}>
            <MenuRoundedIcon />
          </IconButton>
          <IconButton className="suite-icon-button" title="Volver atras">
            <ArrowBackRoundedIcon />
          </IconButton>
        </Box>
        <Typography className="suite-breadcrumb">Calidad en produccion</Typography>
      </Box>

      <Box className="suite-topbar-actions">
        {usingFallback && (
          <Chip
            size="small"
            className="suite-api-status-chip"
            label={sessionStatus === 'loading' ? 'Conectando API' : 'Modo local'}
          />
        )}

        <Box component="button" type="button" className="suite-user-menu" aria-label={`Menu de ${nombreUsuario}`} aria-haspopup="menu" aria-expanded={Boolean(anchorEl)} onClick={(event) => setAnchorEl(event.currentTarget)}>
          <Avatar className="suite-user-avatar">{inicial}</Avatar>
          <Typography className="suite-user-name">{nombreUsuario}</Typography>
          <ExpandMoreRoundedIcon sx={{ fontSize: 19 }} />
        </Box>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem onClick={handleLogout}>
            <LogoutRoundedIcon fontSize="small" sx={{ mr: 1 }} />
            Cerrar sesion
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  )
}
